var _rect, _rect2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPendingCircleIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  x: 0.5,
  y: 0.5,
  fill: "#FFC53A",
  rx: 11.5
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 23,
  height: 23,
  x: 0.5,
  y: 0.5,
  stroke: "#FFC53A",
  rx: 11.5
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 4.333,
  stroke: "#fff",
  strokeWidth: 2
})));
export default SvgPendingCircleIcon;